import React from 'react';
import {fromJS , OrderedMap} from 'immutable';
import { getObjectsBounds } from '../reducers/project';
import config from '../config/app.json';
import { FormattedMessage } from 'react-intl';
import { errorlog } from '../helpers/ErrorLogService';

export default class ItemToolBar extends React.Component {

    constructor(props) {
      super(props);
      this.state                          = {icons : [], type : "vertical", column : "two", canExpand : true};
      this.handleClick      = this.handleClick.bind(this);
      this.handleShortcuts  = this.handleShortcuts.bind(this);
      this.toggleToolBar    = this.toggleToolBar.bind(this);
      this.appUrl = config['APPICONS'][config['APPICONS']['current']]
    }

    static getDerivedStateFromProps(props, state) {
      let toReturn = null;
      
        if(props.selectedItems !== state.prevSelectedItems || props.propertyWindow !== state.prevPropertyWindow || props.textStatus !== state.textStatus || !props.transformStatus.get("transfroming") || props.isToolBarExpanded !== state.isPrevExpanded){
        
        var icons = [];
        toReturn = {selectedItems : props.selectedItems, prevSelectedItems : state.selectedItems, propertyWindow : props.propertyWindow, prevPropertyWindow : state.propertyWindow, textStatus : props.textStatus, prevTextStatus : state.textStatus, isExpanded : props.isToolBarExpanded, isPrevExpanded : state.isExpanded, transformStatus : props.transformStatus, prevTransformStatus : state.transformStatus};
        toReturn.column = "two";
      
          if(props.selectedObjects.size > 1){
            icons = [];
            if(props.selectedObjects.find(x => x.get("type") === "GROUP") === undefined){
              icons.push("group");
            }
            icons.push("delete");
          }else if(props.selectedObjects.size === 1){
            if(props.selectedObjects.first().get("type") === "GROUP"){
              
              icons = ["ungroup"];
            
              if(props.workspaceChildren.filter(function (obj, key) { return props.selectedObjects.first().get("groupChildren").indexOf(key) !== -1 }).some(v => v.get("type") === "TEXT" || v.get("type") === "SHAPE" || v.get("type") === "PROP"))
                icons.push("color");

            }
            else if(props.selectedObjects.first().get("type") === "TEXT"){
              icons = ["effect"];
             
            }
            else if(props.selectedObjects.first().get("type") === "CHR"){
              icons = ["action", "color","effect", "swap", "flip-"+props.selectedObjects.first().get("flipPosition")];
             
            }
            else if(props.selectedObjects.first().get("type") === "PROP" || props.selectedObjects.first().get("type") === "SHAPE"){
              icons = ["effect", "swap", "flip-"+props.selectedObjects.first().get("flipPosition")];
            }
            else if(props.selectedObjects.first().get("type") === "IMG" || props.selectedObjects.first().get("type") === "STOCKIMG" || props.selectedObjects.first().get("type") === "UPLOADS"){
              icons = ["filter", "swap", "flip-"+props.selectedObjects.first().get("flipPosition")];
              if(props.selectedObjects.first().get("type") === "IMG" || props.selectedObjects.first().get("type") === "STOCKIMG" || (props.selectedObjects.first().get("subType") === "UPIMAGE" && props.selectedObjects.first().get("sourceType") !== "svg"))
                icons = ["crop", "filter", "swap", "flip-"+props.selectedObjects.first().get("flipPosition"), "set-bg"];
              else 
                icons = ["effect", "filter", "swap", "flip-"+props.selectedObjects.first().get("flipPosition")];
                if(props.selectedObjects.first().get("sourceType") === "svg"){
                  var mIndex = icons.indexOf("filter");
                  if(mIndex !== -1){
                    icons.splice(mIndex, 1);
                  }
                }
            }

            if(props.propertyWindow.get("component") === "settings")
              icons.push("settings-active");
            else
              icons.push("settings");
            
            icons.push("delete");
          }
        

        if(icons.indexOf("swap") !== -1 && props.swapDetails !== null){
          icons.splice(icons.indexOf("swap"), 1, "swap-active");
        }
        var mIndex;
       
       

        if(icons.length <= 6)
          toReturn.canExpand = false;
        else if(!state.canExpand)
          toReturn.canExpand = true;

        if(!props.isToolBarExpanded && icons.length > 6)
          icons.length = 6;
     

       
        toReturn.icons = icons;

        if(icons.length < 4)
          toReturn.column = "one";
      }
      
      
      return toReturn;
    }

    getCorner(pivotX, pivotY, cornerX, cornerY, angle) {
      var x, y, distance, diffX, diffY;
  
      /// get distance from center to point
      diffX = cornerX - pivotX;
      diffY = cornerY - pivotY;
      distance = Math.sqrt(diffX * diffX + diffY * diffY);
  
      /// find angle from pivot to corner
      angle += Math.atan2(diffY, diffX);
  
      /// get new x and y and round it off to integer
      x = pivotX + distance * Math.cos(angle);
      y = pivotY + distance * Math.sin(angle);
  
      return { x: x, y: y };
    }
  
    getSelectionBoxBounds(data) {
      var angle = data.angle * Math.PI / 180
      var c1, c2, c3, c4,    /// corners
        bx1, by1, bx2, by2, bounds;
      c1 = this.getCorner(data.cx, data.cy, data.x, data.y, angle);
      c2 = this.getCorner(data.cx, data.cy, data.x + data.width, data.y, angle);
      c3 = this.getCorner(data.cx, data.cy, data.x + data.width, data.y + data.height, angle);
      c4 = this.getCorner(data.cx, data.cy, data.x, data.y + data.height, angle);
      /// get bounding box
      bx1 = Math.min(c1.x, c2.x, c3.x, c4.x);
      by1 = Math.min(c1.y, c2.y, c3.y, c4.y);
      bx2 = Math.max(c1.x, c2.x, c3.x, c4.x);
      by2 = Math.max(c1.y, c2.y, c3.y, c4.y);
  
      bounds = { x: parseFloat(bx1.toFixed(2)), y: parseFloat(by1.toFixed(2)), width: parseFloat((bx2 - bx1).toFixed(2)), height: parseFloat((by2 - by1).toFixed(2)) };
  
      return bounds;
    }
  
    getObjectsBounds(objects, zoomFactor) {
      var minX = 0, maxX = 0, minY = 0, maxY = 0, width = 0, height = 0;
      var count = 0;
      objects.entrySeq().forEach(([key, item]) => {
        let bounds, x, y, width, height;
        bounds = this.getSelectionBoxBounds({ x: item.get("x"), y: item.get("y"), cx: item.get("x") + item.get("width") / 2, cy: item.get("y") + item.get("height") / 2, width: item.get("width"), height: item.get("height"), angle: item.get("angle") });
        
        x = bounds.x; y = bounds.y; width = bounds.width; height = bounds.height;
  
        if (count === 0) {
          minX = x; maxX = x + width; minY = y; maxY = y + height;
          count++;
        } else {
          minX = Math.min(minX, x); maxX = Math.max(maxX, x + width); minY = Math.min(minY, y); maxY = Math.max(maxY, y + height);
        }
      });
      
      width = (maxX - minX) * this.props.zoomFactor; height = (maxY - minY) * this.props.zoomFactor; minX *= this.props.zoomFactor; minY *= this.props.zoomFactor;

      let x = (this.props.workspaceWidth * this.props.zoomFactor <= this.props.workspaceBounds.get("width"))?this.props.workspaceBounds.get("cx") - (this.props.workspaceWidth * this.props.zoomFactor) / 2:this.props.workspaceBounds.get("cx") - this.props.workspaceBounds.get("width") / 2, y = (this.props.workspaceHeight * this.props.zoomFactor <= this.props.workspaceBounds.get("height"))?this.props.workspaceBounds.get("cy") - (this.props.workspaceHeight * this.props.zoomFactor) / 2:this.props.workspaceBounds.get("cy") - this.props.workspaceBounds.get("height") / 2;
     
      return { x: x + minX, y: y + minY, width: width, height: height };
     
    }

    getToolBarXY(){
      
      let allItems;
      if(this.props.selectedItems.size > 0){
        allItems = this.props.selectedObjects;
        if(this.props.selectedItems.size === 1){
          let item = this.props.selectedObjects.first();
          
        }
      }
      if(allItems !== undefined){
        let bounds = this.getObjectsBounds(allItems, this.props.zoomFactor);
        var stageLeft   = this.props.workspaceStage.getIn(["left", "menu"]);
        var stageTop    = this.props.workspaceStage.getIn(["top", "menu"]);
        var stageRight  = window.innerWidth;
        var stageBottom = window.innerHeight - this.props.workspaceStage.getIn(["bottom", "timeline"]);

        if( document.getElementsByClassName("app-lib-container")[0].className.indexOf("opened") !== -1)
          stageLeft += this.props.workspaceStage.getIn(["left", "library"]);
        
        if(this.props.propertyWindow.get("isOpened") === true && document.getElementsByClassName("property-window-container")[0]){
          stageRight -= document.getElementsByClassName("property-window-container")[0].offsetWidth;
        }
        else if(this.props.showSlidePanel){
          stageRight -= document.getElementsByClassName("slide-panel")[0].offsetWidth;
        }
       
        let toolBarX  = bounds.x + bounds.width + 10, toolBarY = bounds.y;

        if(toolBarX < stageLeft)
          toolBarX = stageLeft;
        
        if(toolBarX + this.toolBar.offsetWidth > stageRight){
          toolBarX = bounds.x - this.toolBar.offsetWidth - 10;
          if(toolBarX + this.toolBar.offsetWidth > stageRight)
            toolBarX = stageRight - this.toolBar.offsetWidth - 10;
        }

        if(toolBarY < stageTop){
          toolBarY = stageTop + 10;
        }

        if(toolBarY + this.toolBar.offsetHeight > stageBottom){
          toolBarY = stageBottom - this.toolBar.offsetHeight - 10;
        }
        
        if(bounds.x - this.toolBar.offsetWidth <= stageLeft && bounds.x + bounds.width + this.toolBar.offsetWidth >= stageRight && bounds.y < stageTop && bounds.y + bounds.height >= stageBottom){
         
          toolBarY = stageTop + 10;
          toolBarX = stageRight - this.toolBar.offsetWidth - 10;
        }else if(bounds.x - this.toolBar.offsetWidth <= stageLeft && bounds.x + bounds.width + this.toolBar.offsetWidth >= stageRight){
          toolBarX = stageRight - this.toolBar.offsetWidth - 10;
        }
        else if( bounds.y < stageTop && bounds.y + bounds.height >= stageBottom){
          toolBarY = stageTop + 10;
        }else if(bounds.x + bounds.width + this.toolBar.offsetWidth <= stageRight){
          toolBarX = bounds.x + bounds.width + 10;
        }
        return {x : toolBarX, y : toolBarY};
      }
      else{
        return {x : stageRight - this.toolBar.offsetWidth - 10, y : stageTop + 10};
      }
    }

    componentDidMount(){
      let toolBarXY =  this.getToolBarXY();
      this.toolBar.style.left = toolBarXY.x + "px";
      this.toolBar.style.top  = toolBarXY.y + "px";
    }

    componentDidUpdate(prevProps, prevState){
        let toolBarXY =  this.getToolBarXY();
        this.toolBar.style.left = toolBarXY.x + "px";
        this.toolBar.style.top  = toolBarXY.y + "px";
      this.flipClicked = false;
      if(!this.props.isWorkspaceTextFocus && this.props.shortcutName !== prevProps.shortcutName && this.props.shortcutName !== "")
        this.handleShortcuts(this.props.shortcutName);
    }

    handleShortcuts(option) {
      switch(option)
      {
        case "FLIP_ITEM":
          this.handleClick('keys',"flip");
          break;
        case "GROUP_ITEM":
            this.handleClick('keys',"group");
          break;
        case "UN_GROUP_ITEM":
          this.handleClick('keys',"ungroup");
          break;
        case "DELETE_ITEM":
        case "DELETE_ITEM_MAC":
          this.handleClick('keys',"delete");
          break;
        default:
          break;
      }
    }

    DistanceTwoPoints(x1, x2,  y1, y2) {
    var dx = x1-x2;
    var dy = y1-y2;
    return Math.sqrt(dx * dx + dy * dy);
  }

    handleClick(e, icon){
      try {
      if(icon.indexOf("flip") !== -1){
        if (this.props.selectedItems.size === 1 && (this.props.selectedObjects.getIn([this.props.selectedItems.get(0), "type"]) !== "TEXT" || this.props.selectedObjects.getIn([this.props.selectedItems.get(0), "subType"]) === "CALLOUT" )) {
          let nextBtn = document.querySelector('.next_step');
          if(nextBtn){
            nextBtn.classList.remove('disable');
            this.flipClicked = true;
          }
          var flipValue = this.props.selectedObjects.getIn([this.props.selectedItems.get(0), "flipPosition"]);
          this.props.flipItem({ active : this.props.selectedItems.get(0), flipPosition : (flipValue >= 3)?0:flipValue + 1, selectedScene : this.props.selectedScene }, this.props.socket);
        }
      }
      else{
        var nextBtn = document.querySelector('.next_step');
        let breakFlow = false;
        switch(icon){
        
          case "effect":
            this.props.setPropertyWindow({component : "settings", type : this.props.selectedObjects.first().get("type"),subWindow:"enter", isOpened : true});
            break;
         
          case "flip":
            if (this.props.selectedItems.size === 1 && (this.props.selectedObjects.getIn([this.props.selectedItems.get(0), "type"]) !== "TEXT" || this.props.selectedObjects.getIn([this.props.selectedItems.get(0), "subType"]) === "CALLOUT" )) {
              var flipValue = this.props.selectedObjects.getIn([this.props.selectedItems.get(0), "flipPosition"]);
              this.props.flipItem({ active : this.props.selectedItems.get(0), flipPosition : (flipValue >= 3)?0:flipValue + 1, selectedScene : this.props.selectedScene }, this.props.socket);
            }
          break;
          case "delete":
            if (this.props.selectedItems.size > 0) {
              this.props.deleteItem({selectedItems : this.props.selectedItems.toArray(), selectedScene : this.props.selectedScene}, this.props.socket);
              this.props.suggestionPopup({
                  show : false,
                  type : '',
                  subType : ''
              })
            }
          break;
          case "swap":
            if(this.props.selectedItems.size === 1){
              this.props.selectedObjects.map(data => {
                if(data.get('isBlob')){
                  breakFlow = true;
                }
              })

              if(breakFlow){
                this.props.manageToast({action : "add", type : "error", "message" : "br.sw", formatId: "msg"});
                return;
              }
              var currentItem = this.props.selectedObjects.get(this.props.selectedItems.get(0));
              var swapProp=currentItem.toJS();
              var itemText = null;
              if(currentItem.get("type") === "TEXT"){
                this.props.updateTextStatus({id: null, isSelected : false, isFocused : false, container : null, isRTL : false, isGrouped :false});
                let text = document.getElementById(this.props.selectedItems.get(0)).getElementsByClassName("text-container")[0].innerHTML;
                itemText = currentItem.get("textData");
                itemText = itemText.setIn("htmlText", text);
              }

           

                document.getElementsByClassName('app-lib-container')[0].style.zIndex = 11;
                let swapObject = {id : this.props.selectedItems.get(0), type: currentItem.get("type"), subType: currentItem.get("subType"), x : currentItem.get("x"), y : currentItem.get("y"), width : currentItem.get("width"), height : currentItem.get("height"), angle : currentItem.get("angle"), enterStart : currentItem.get("enterStart"), enterEnd : currentItem.get("enterEnd"),enterEffectName : currentItem.get("enterEffectName"),flipPosition : currentItem.get("flipPosition"), filter : currentItem.get("filter"), index : currentItem.get("index"), text : itemText, voiceOver: currentItem.get("voiceOver"), orbit :  currentItem.get("orbit"), opacity : currentItem.get("opacity"),animType:currentItem.get("animType"),animIndex:currentItem.get("animIndex")};

              if(currentItem.get("type") === "CHR"){
                swapObject.parts = currentItem.get("parts");
                swapObject.colors = currentItem.get("colors");
                swapObject.animdata = currentItem.get("animdata");
                swapObject.defaultColor = currentItem.get("defaultColor");
                swapObject.expression = currentItem.get("expression");
                swapObject.genderType = currentItem.get("genderType");
                swapObject.pose = currentItem.get("pose");
                swapObject.src = currentItem.get("src");
                swapObject.expFlag = currentItem.get("expFlag");
                swapObject.mouthAction = currentItem.get("mouthAction");
              }
              swapProp.emptySwap=true;
              swapProp.selectedScene=this.props.selectedScene;
              swapProp.item_id=this.props.selectedItems.get(0);
              swapProp.undoSwap = true;
              if(['CHR', 'CCHR'].indexOf(currentItem.get('subType')) !== -1){
                swapProp.checkAudio = [];
                swapProp['voiceOverData'] = [];
              }
           
             
              this.props.swapItemUndo(swapProp);
              this.props.swapItem(swapObject);
              if(nextBtn){
                  this.props.nextBtnClicked(true);
                  nextBtn.classList.remove('disable');
                  nextBtn.click();
              }
            
            }
          break;
          case "swap-active":
            this.props.swapItem("");
          break;

          case "group":
            if(this.props.selectedItems.size > 1){
              if(this.props.selectedObjects.find(x => x.get("type") === "GROUP") === undefined){
                if (this.props.selectedItems.size > 0)
                {
                  var selectedObjects = this.props.selectedObjects;
                  
                  let maxItem = selectedObjects.maxBy(x => x.get("index"));
                  var minAnimIndex  = selectedObjects.minBy(x=>x.get('animIndex'));
                  selectedObjects.entrySeq().forEach(([key, item]) =>
                  {
                    if(item.get("type") === "TEXT" || item.get("type") === "SHAPE"){
                      selectedObjects = selectedObjects.set(key, item.setIn(["textData", "formats", "others", "isFixedWidth"], true));
                    }
                  });

                  let bounds = getObjectsBounds(selectedObjects);

                  selectedObjects = selectedObjects.sortBy(function (value, key) {return value.get("index");}).toOrderedMap();

                  var uniqueId = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5) + (new Date().getTime()).toString();
                  let enterStart = selectedObjects.minBy(x => x.get("enterStart")).get("enterStart"), exitEnd = selectedObjects.maxBy(x => x.get("exitEnd")).get("exitEnd");
                  let enterEnd = 0, exitStart = 0, enterEffectName = "no_Effect", exitEffectName = "no_Effect";
                  if (exitEnd - enterStart <= 1 && exitEnd >= 2)
                    enterStart = exitEnd - 2;
                  if (enterStart === exitEnd)
                    enterStart = 0;
                  var workspaceItems = fromJS({});
              
                  workspaceItems = workspaceItems.set(uniqueId,
                    fromJS({
                      "index": maxItem.get('index'),
                      "animIndex":minAnimIndex.get('animIndex'),
                      "width": bounds.width,
                      "height": bounds.height,
                      "x": bounds.x,
                      "y": bounds.y,
                      "angle": 0,
                      "type": "GROUP",
                      "flipPosition": 0,
                      "opacity": 1,
                      "groupChildren": selectedObjects.keySeq().toArray(),
                      "enterStart": enterStart,
                      "enterEffectName": enterEffectName,
                      "exitStart": exitStart,
                      "enterEnd": enterEnd,
                      "animType":'On Load',
                    })
                  );
                }
                if(nextBtn){
                    this.props.nextBtnClicked(true);
                    nextBtn.classList.remove('disable');
                    nextBtn.click();
                }
                let workspaceItemsAnimIndexOrder = {};
                let count = 0 ;
                let workspaceItemsCopy = fromJS({workspaceItems:this.props.workspaceItems}).sortBy(item => item.get('animIndex'));
                const getAllItems = fromJS(this.props.selectedItems).reduce((map, key) => map.delete(key), workspaceItemsCopy.get( "workspaceItems"));
                workspaceItemsCopy = workspaceItemsCopy.setIn(["scenes", this.props.selectedScene, "workspaceItems"], getAllItems);
                workspaceItemsCopy = workspaceItemsCopy.setIn(["scenes", this.props.selectedScene, "workspaceItems"], workspaceItemsCopy.getIn(["scenes", this.props.selectedScene, "workspaceItems"]).merge(fromJS(workspaceItems)));
                workspaceItemsCopy.getIn(['scenes',this.props.selectedScene,'workspaceItems']).sortBy(item => item.get('animIndex')).entrySeq().forEach(([key,item])=>{
                  workspaceItemsAnimIndexOrder[key]=count;
                  count++;
                });
                this.props.groupObjects({selectedScene : this.props.selectedScene, selectedItems : this.props.selectedItems, workspaceItems : workspaceItems, workspaceChildren : selectedObjects,workspaceItemsOrder:workspaceItemsAnimIndexOrder},this.props.socket);
              }else{
                this.props.manageToast({action : "add", type : "error", "message" : "c.n.g", formatId: "msg"});
              }
            }
          break
          case "ungroup":
            if(this.props.selectedItems.size === 1){

              let parentItem = this.props.selectedObjects.get(this.props.selectedItems.get(0));
              let parentIndex = parentItem.get("index");

              let childIds = parentItem.get("groupChildren");
              
              if(childIds && childIds.count()>0){
              let children = this.props.workspaceChildren.filter(function (obj, key) { return childIds.keyOf(key) !== undefined; });

              var indexToUpdate = parentIndex - children.size + 1;

              if(this.props.textStatus.get("isFocused") === true && children.has(this.props.textStatus.get("id"))){
              
                children = children.setIn([this.props.textStatus.get("id"), "textData", "htmlText"], document.getElementById(this.props.textStatus.get("id")).getElementsByClassName("text-container")[0].innerHTML);
              }
             
              childIds.entrySeq().forEach(([index, key]) =>
              {
                let item = children.get(key);
                let itemX = item.get("xRatio") && item.get("xRatio") !== null ? parentItem.get("x") + ((item.get("xRatio") * parentItem.get("width")) / 100) : item.get("x"), itemY = item.get("yRatio") && item.get("yRatio") !== null ? parentItem.get("y") + ((item.get("yRatio") * parentItem.get("height")) / 100) : item.get("y"), itemWidth = item.get("widthRatio") && item.get("widthRatio") !== null ? ((item.get("widthRatio") * parentItem.get("width")) / 100) : item.get("width"), itemHeight = item.get("heightRatio") && item.get("heightRatio") !== null ? ((item.get("heightRatio") * parentItem.get("height")) / 100) : item.get("height");

                if(item.get("type") === "SHAPE" || item.get("type") === "TEXT"){
                  itemX = item.get("x"); itemY = item.get("y"); itemWidth = item.get("width"); itemHeight = item.get("height");

                  if(parentItem.get("subType") === "TXTGRP"){
                    itemWidth += this.props.textOffset;
                    itemHeight += this.props.textOffset;
                    children = children.setIn([key, "textData", "formats", "containerStyle", "margin"], (this.props.textOffset / 2) + "px");
                    children = children.setIn([key, "width"], itemWidth).setIn([key, "height"], itemHeight);
                   
                  }
                }

                let pcx = parentItem.get("x") + parentItem.get("width") / 2, pcy = parentItem.get("y") + parentItem.get("height") / 2;
                let icx = itemX + itemWidth / 2, icy = itemY + itemHeight / 2;
                
                var angleS = Math.atan2(icy - pcy, icx - pcx) * (180 / Math.PI);
              
                let dist = Math.sqrt((Math.pow(pcx - icx, 2)) + (Math.pow(pcy - icy, 2)));

                itemX = (Math.cos((angleS + parentItem.get("angle")) * Math.PI / 180) * Math.abs(dist) + pcx) - item.get("width") / 2;
                itemY = (Math.sin((angleS + parentItem.get("angle")) * Math.PI / 180) * Math.abs(dist) + pcy) - item.get("height") / 2;

                let item_angle = parentItem.get("angle") + item.get("angle");

                
                children = children.setIn([key, "x"], itemX)
                  .setIn([key, "y"], itemY)
                  .setIn([key, "angle"], item_angle)
                  .setIn([key, "index"], indexToUpdate)
                indexToUpdate++;
              });
                const selectedScene = this.props.selectedScene;
                let workspaceItemsAnimIndexOrder = {};
                let count = 0 ;
                  let workspaceItemsCopy = fromJS({workspaceItems:this.props.workspaceItems}).sortBy(item => item.get('animIndex'));
                let childIdstep = this.props.projectData.getIn(["scenes", selectedScene, "workspaceItems", this.props.selectedItems.first(), "groupChildren"]);
                let getAllItems = fromJS(this.props.selectedItems).reduce((map, key) => map.delete(key), workspaceItemsCopy.get( "workspaceItems"));
                workspaceItemsCopy = workspaceItemsCopy.setIn(["scenes", selectedScene, "workspaceItems"], getAllItems);
                let unGroupedItems = fromJS(children);
                workspaceItemsCopy = workspaceItemsCopy.setIn(["scenes", selectedScene, "playHeadValue"], unGroupedItems.maxBy(x => x.get("enterStart")).get("enterStart"));
               let allWorkspaceItems     = workspaceItemsCopy.getIn(["scenes", selectedScene, "workspaceItems"]).merge(unGroupedItems);
                
              let  allChildren = childIdstep.toArray().reduce((map, key) => map.delete(key), this.props.projectData.getIn(["scenes", selectedScene, "workspaceChildren"]));
                
                allWorkspaceItems = allWorkspaceItems.sortBy(function (value, key) {
                  return value.get("index");
                });
                
                workspaceItemsCopy = workspaceItemsCopy.setIn(["scenes", selectedScene, "workspaceItems"], allWorkspaceItems).setIn(["scenes", selectedScene, "workspaceChildren"], allChildren); 
                
                workspaceItemsCopy.getIn(['scenes',this.props.selectedScene,'workspaceItems']).sortBy(item => item.get('animIndex')).entrySeq().forEach(([key,item])=>{
                  workspaceItemsAnimIndexOrder[key]=count;
                  count++;
                });
              this.props.unGroupObjects({selectedScene : this.props.selectedScene, selectedItems : this.props.selectedItems, workspaceChildren : children, workspaceItems : fromJS(this.props.selectedObjects.toJS()),workspaceItemsOrder:workspaceItemsAnimIndexOrder}, this.props.socket);
             }
              if(nextBtn){
                this.props.nextBtnClicked(true);
                  nextBtn.classList.remove('disable');
                  nextBtn.click();
              }
            }else{
              if(nextBtn){
                this.props.nextBtnClicked(true);
                nextBtn.classList.remove('disable');
                nextBtn.click();
              }
            }
          break
          case "action":
            this.props.setPropertyWindow({component: "action"});
            if(nextBtn){
              this.props.nextBtnClicked(true);
              nextBtn.classList.remove('disable');
              nextBtn.click();
          }
          break;
          case "filter":
          this.props.setPropertyWindow({component: "filterSetting"});
          break;
          case "color":
         this.props.setPropertyWindow({component: "color"});
            if(nextBtn){
              this.props.nextBtnClicked(true);
                nextBtn.classList.remove('disable');
                nextBtn.click();
            }
          break;
          case "settings-active":
            this.props.setPropertyWindow({component : "", type : "",isOpened : false});
            if(nextBtn){
              this.props.nextBtnClicked(true);
                nextBtn.classList.remove('disable');
                nextBtn.click();
            }
          break;
          case "settings":
           
            this.props.setPropertyWindow({component : "settings", type : this.props.selectedObjects.first().get("type"), isOpened : true});
            if(nextBtn){
              this.props.nextBtnClicked(true);
                nextBtn.classList.remove('disable');
                nextBtn.click();
            }
            break;

        

         

          case "crop": 
            this.props.toggleCrop();
          break;
          case "set-bg":
              let selectedItem = this.props.selectedObjects.get(this.props.selectedItems.get(0)), subType;
     
              let bgType = selectedItem.get("type");
              if(bgType !== "STOCKIMG" && bgType !== 'IMG' && selectedItem.get("subType") !== undefined && selectedItem.get("subType") !== "" && selectedItem.get("subType") !== null)
                bgType = selectedItem.get("subType");
              
              if(bgType === "STOCKIMG" || bgType === 'IMG')
                subType = selectedItem.get("subType");
              if(selectedItem.get("subType") === "GIPHY")
                bgType = selectedItem.get("subType");
              
              let bgFilter = "", isBlob = false;
              
              if(selectedItem.get("filter") !== undefined && selectedItem.get("filter") !== "")
                bgFilter = selectedItem.get("filter");
              if(selectedItem.get('isBlob')){
                isBlob = true;
              }
              let color = [], defaultColor = '';
              if(selectedItem.get('type') === 'UPLOADS' && selectedItem.get('sourceType').includes('svg') && selectedItem.get('colors') && selectedItem.get('colors').size){
                color = selectedItem.get('colors');
                defaultColor = selectedItem.get('defaultColor');
              }
              this.props.changeBg({selectedScene : this.props.selectedScene, selectedItems : this.props.selectedItems, isBlob, assetId : selectedItem.get("assetId"), stockId : selectedItem.get("assetId"), bgType : bgType, subType : subType, sourceType : selectedItem.get("sourceType"), bgHeight : document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("img")[0].naturalHeight, bgWidth : document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("img")[0].naturalWidth, source : selectedItem.get("src"), thumb : selectedItem.get("thumb"), color, defaultColor, isCustomBg : true, bgFilter : bgFilter, flipPosition : selectedItem.get("flipPosition")}, this.props.socket);
          break;

          default :
          break;
        }
      }
    } catch (error) {
      //Error Severity: LOW
      errorlog(error, error.message, "ItemToolbar-handleClick")
    }
    }

    toggleToolBar(e){
      try {
      this.props.toggleToolBar();
      } catch (error) {
        //Error Severity: LOW
        errorlog(error, error.message, "ItemToolbar-toggleToolBar")
      }
    }

    changeImgSrc(e, src){
      try {
      e.currentTarget.src = src;
      } catch (error) {
        //Error Severity: LOW
        errorlog(error, error.message, "ItemToolbar-changeImgSrc")
      }
    }

    render() {
      
      let iconsList = [];
      
        this.state.icons.map(function(icon, index){
          let selectedItem = this.props.selectedObjects.get(this.props.selectedItems.get(0));
          if(selectedItem && selectedItem.get('subType') === 'ECHR' && ['lipsync'].indexOf(icon) !== -1){
            return;
          }
          iconsList.push(<React.Fragment key = {index+"a"}>
            <li key={index} onMouseMove = {(e) => {
              let toolTip = document.querySelector('.wrkspc_'+icon+'Item_tool_tip');
              let toolItem = document.querySelector('.item-tool.'+icon);
              var pageX = e.pageX,
              pageY = e.pageY;
              if(toolItem){
                if(toolTip){
                  var toolContainer = document.querySelector('.item-tool-container'),
                  toolContPos = toolContainer.getBoundingClientRect();

                    toolTip.style.display = '';
                    toolTip.style.top = pageY - toolContPos.top - 5 + 'px';
                    toolTip.style.left = pageX - toolContPos.left + 15 + 'px';
                  
                }
              }
              
            }} onMouseLeave = {(e) => {
              let toolTip = document.querySelector('.wrkspc_'+icon+'Item_tool_tip');
              if(toolTip){
                  toolTip.style.display = 'none';
              }
            }} className = {"item-tool " + icon + `${(icon.includes('flip')) ? ' flip' : ''}` + `${(this.flipClicked && icon.includes('flip')) ? ' highlighted_node': ''}`} onClick = {(e) => {
              this.handleClick(e, icon);
              let toolTip = document.querySelector('.wrkspc_'+icon+'Item_tool_tip');
              if(toolTip){
                  toolTip.style.display = 'none';
              }
            }} ></li>
            <FormattedMessage id={"ws."+((icon.includes('-') && (icon.includes('flip') || icon.includes('settings'))) ? icon.split('-')[0] : icon)+".t.t"} children={(val) => (
              <div className={"item_tools_tooltip wrkspc_"+icon+"Item_tool_tip"} style={{'display' : 'none'}}>{val}</div>
            )}></FormattedMessage>
          </React.Fragment>
          );
        }.bind(this));
        
      
        return(
        <div data-html2canvas-ignore="true" ref={(instance) => this.toolBar = instance} className = {"item-tool-bar " + this.state.type + " " + this.state.column + (iconsList.length === 0?" padding-none":"")} >{
          (iconsList.length > 0)?
            <div className="item-tool-container">
              <ul>{iconsList}</ul>
            </div>:null
          }{this.state.canExpand?<div onClick = {(e) => {
            this.toggleToolBar(e);
            let nextBtn = document.querySelector('.next_step');
            if(nextBtn){
              this.props.nextBtnClicked(true);
              nextBtn.classList.remove('disable');
              nextBtn.click();
          }
          }} className="item-tool-toggle"><img style = {(this.state.isExpanded?{transform : "rotate(180deg)"}:{})} onMouseEnter = {(e) => this.changeImgSrc(e, this.appUrl + "/images/item-tools/toggle-hover.svg")} onMouseLeave = {(e) => this.changeImgSrc(e, this.appUrl + "/images/item-tools/toggle.svg")} src={this.appUrl + "/images/item-tools/toggle.svg"} alt="Toggle"/></div>:null}
        </div>);
      
    }
  }



// WEBPACK FOOTER //
// ./src/components/ItemToolBar.js